import { HivePaymentData } from '@/api/financial/types';
import { Constants } from '@/constants/finance';
import { formatReal } from '@/helpers';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';

import { PaymentBox } from '../styles';
import { PaymentStatusBadge } from './PaymentStatusBadge';

export const PaymentHeader = memo(function PaymentHeader({
  paymentData,
}: {
  paymentData: HivePaymentData | undefined;
}) {
  if (!paymentData) return null;
  return (
    <PaymentBox>
      <Box
        display="flex"
        flexDirection="row"
        width="380px"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          {Constants.paymentNumber}
          <Typography fontWeight={600}>{paymentData.reference_id}</Typography>
        </Box>
        <PaymentStatusBadge status={paymentData.status} />
      </Box>
      <Box minWidth={120}>
        {Constants.totalValue}
        <Typography fontWeight={600}>
          {paymentData && formatReal(paymentData.amount)}
        </Typography>
      </Box>
    </PaymentBox>
  );
});
